import EntryModal from './EntryModal';

export default EntryModal;
